import { Pipe, PipeTransform } from '@angular/core';
import { nodesToKmph } from '@mri/functions';

@Pipe({
  name: 'convertSpeed',
  standalone: true
})
export class ConvertSpeedPipe implements PipeTransform {

  transform(value: number, unit: string = 'km'): number {
    if(unit == 'km') return nodesToKmph(value)
    return value
  }

}
